import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AnalyticServices } from '@/services/apis';

interface StateType {
  stats: any;
  applications: any;
}

const initialState: StateType = {
  stats: {},
  applications: []
};

export const fetchBasicAnalyticStats = createAsyncThunk('analytics/fetchBasicAnalyticStats', async ({ domainName }: any) => {
  const response = await AnalyticServices.fetchBasicStats({
    domainName
  });

  return response;
});

export const fetchApplicationAnalyticStats = createAsyncThunk(
  'analytics/fetchApplicationAnalyticStats',
  async ({ domainName }: any) => {
    const response = await AnalyticServices.fetchApplicationStats({
      domainName
    });

    return response;
  }
);

export const AnalyticSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchBasicAnalyticStats.pending, (state) => {
      return { ...state, loading: true };
    });
    builder.addCase(fetchBasicAnalyticStats.fulfilled, (state, { payload }) => {
      return { ...state, stats: payload?.result, loading: false };
    });
    builder.addCase(fetchBasicAnalyticStats.rejected, (state) => {
      return { ...state, stats: {}, loading: false };
    });
    builder.addCase(fetchApplicationAnalyticStats.pending, (state) => {
      return { ...state, loading: true, applications: [] };
    });
    builder.addCase(fetchApplicationAnalyticStats.fulfilled, (state, { payload }) => {
      return { ...state, applications: payload?.result?.applications, loading: false };
    });
    builder.addCase(fetchApplicationAnalyticStats.rejected, (state) => {
      return { ...state, applications: [], loading: false };
    });
  }
});

export const AnalyticSliceSelector = (state: any) => state.analytics;

export default AnalyticSlice.reducer;
